// eslint-disable-next-line no-unused-vars
import { useTranslation, withTranslation } from "react-i18next";
import React, { PureComponent } from 'react';
import Layout from 'Components/Layout';
import { Container, Card, CardBody } from 'reactstrap';
import BusinessList from 'Components/Business/BusinessList';
class Main extends PureComponent {
  render() {
    const { t } = this.props;
    return <Layout>
        <div className="pageHeader" style={{
        padding: '2rem 1rem',
        textAlign: 'center',
        marginBottom: '2rem'
      }}>
          <h2 className="mb-3" style={{
          fontSize: 'var(--text-2xl)',
          fontWeight: 'var(--font-weight-bold, 600)'
        }}>{t("Your Business Records")}</h2>
          <p className="text-muted" style={{
          fontSize: 'var(--text-base)',
          maxWidth: 'var(--container-md)',
          margin: '0 auto'
        }}>{t("A domain name is required to create a business listing.")}<br />
            <a href='/learn' style={{
            color: 'var(--color-primary, #007bff)',
            textDecoration: 'none',
            fontWeight: '500'
          }}>{t("What's a domain name?")}</a>
          </p>
        </div>
        
        <Container style={{
        maxWidth: 'var(--container-lg)'
      }}>
          <Card className="shadow-sm mb-4 border-0" style={{
          borderRadius: '12px',
          background: 'rgba(255, 255, 255, 0.6)',
          backdropFilter: 'blur(10px)'
        }}>
            <CardBody className="text-center p-4">
              <p style={{
              fontSize: 'var(--text-base)',
              margin: 0,
              color: '#444'
            }}>{t("Please contact us about including your listing in the HeresMyInfo mobile application business directory.")}<br />
                <a href='/support' className="btn btn-outline-success mt-3" style={{
                borderRadius: '20px',
                padding: '0.5rem 1.5rem',
                fontWeight: '500'
              }}>{t("Contact Representative")}</a>
              </p>
            </CardBody>
          </Card>
          
          <BusinessList />
        </Container>
      </Layout>;
  }

}

export default withTranslation()(Main);